import * as Sentry from '@sentry/react';

export interface ErrorContext {
  component?: string;
  action?: string;
  userId?: string;
  sessionId?: string;
  route?: string;
  timestamp?: string;
  [key: string]: unknown;
}

export const logError = (error: Error | string | unknown, context?: ErrorContext) => {
  const errorContext: ErrorContext = {
    timestamp: new Date().toISOString(),
    route: window.location.pathname,
    ...context,
  };

  // Log to Sentry
  if (error instanceof Error) {
    Sentry.captureException(error, {
      tags: {
        component: errorContext.component || 'unknown',
        action: errorContext.action || 'unknown',
        errorType: 'application_error',
      },
      contexts: {
        app: {
          route: errorContext.route,
          userId: errorContext.userId,
          sessionId: errorContext.sessionId,
        },
      },
      extra: {
        ...errorContext,
        fullError: error,
      },
    });
  } else {
    Sentry.captureMessage(typeof error === 'string' ? error : 'Unknown error occurred', {
      level: 'error',
      tags: {
        component: errorContext.component || 'unknown',
        action: errorContext.action || 'unknown',
        errorType: 'application_message',
      },
      contexts: {
        app: {
          route: errorContext.route,
          userId: errorContext.userId,
          sessionId: errorContext.sessionId,
        },
      },
      extra: {
        error,
        ...errorContext,
      },
    });
  }
};
